import { connect } from 'react-redux';
import TourListView from '../views/TourListView';

const mapStateToProps = (state) => {
    return {
        tourList: state.tourList,
    };
};

export default connect(mapStateToProps)(TourListView);